import Model, { belongsTo } from '@ember-data/model';
import type { AsyncBelongsTo } from '@ember-data/model';
import type FlowModel from 'garaje/models/flow';

class FlowVisitWorkflowModel extends Model {
  @belongsTo('flow', { async: true, inverse: 'flowVisitWorkflow' }) declare flow: AsyncBelongsTo<FlowModel>;
}

export default FlowVisitWorkflowModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'flow-visit-workflow': FlowVisitWorkflowModel;
  }
}
